// extracted by mini-css-extract-plugin
export default {"baseLayout":"BaseLayout_baseLayout__jAYrB"};